import { useCallback } from 'react'
import { useWallet as _useWallet } from '@solana/wallet-adapter-react'
import { useWalletModal } from '@solana/wallet-adapter-react-ui'

import { STORAGE_KEY } from '@/constants/common'
import { isAppWallet } from '@/lib/solana/adapters'
import { getDeviceType } from '@/lib/utils'

export const useWallet = () => {
  const walletModal = useWalletModal()
  const { disconnect: _disconnect, wallet, select } = _useWallet()

  const connect = useCallback(() => walletModal.setVisible(true), [walletModal])

  const disconnect = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY.CONNECT_AT)
    _disconnect()
    // 这里兼容移动端手段断开链接没响应
    if (wallet && isAppWallet(wallet) && getDeviceType().mobile) {
      select(null)
      window.location.reload()
    }
  }, [_disconnect, select, wallet])

  return {
    connect,
    disconnect
  }
}
